import React from 'react'
//import SyncAltIcon from '@material-ui/icons/SyncAlt'

import LastUpdateBlock from 'components/LastUpdateBlock/LastUpdateBlock'
import { getLastUpdateSelector } from 'redux/reducers/equipments'
import { useShallowEqualSelector } from 'custom-hooks'

const CompareSection = () => {
  const lastUpdateDate = useShallowEqualSelector(getLastUpdateSelector)

  return (
    <div className="compare_section">
      <LastUpdateBlock date={lastUpdateDate} />
      {/* <Button startIcon={<SyncAltIcon />} className="compare_button">
        Compare
      </Button> */}
    </div>
  )
}

export default CompareSection
